import {
  RECEIVED_USER_ROLES_FOR_SPONSOR,
  RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR,
  PUBLISH_PERMISSION_MATRIX,
  FETCHING_ROLES,
  RECEIVED_ROLES,
  RECEIVED_ROLES_ERROR
} from '../actions/actionTypes';

const rolesInit = {
  error: null,
  roles: null,
  rolesForSponsor: null,
  isFetchingRoles: null,
  matrix: {}
};

const rolesReducer = (state = rolesInit, action) => {
  switch (action.type) {
    case RECEIVED_USER_ROLES_FOR_SPONSOR:
      return Object.assign({}, state, { error: null, rolesForSponsor: action.payload });
    case RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR:
      return Object.assign({}, state, { error: action.payload.error });
    case RECEIVED_ROLES:
      return Object.assign({}, state, { error: null, isFetchingRoles: false, roles: action.payload.roles });
    case FETCHING_ROLES:
      return Object.assign({}, state, { error: null, isFetchingRoles: true });
    case RECEIVED_ROLES_ERROR:
      return Object.assign({}, state, { isFetchingRoles: false, error: action.payload.error });
    case PUBLISH_PERMISSION_MATRIX:
      return Object.assign({}, state, { matrix: action.payload });
    default:
      return state;
  }
};

export default rolesReducer;
